export default __webpack_public_path__ + "img/bluKTASh.85c08065.svg";